import { defineMessages } from '../../i18n/messages';

export const PricingPreviewMessages = defineMessages({
  TITLE: {
    id: 'homepage.pricing_preview.title',
    text: 'Simple, Transparent Pricing',
    description: 'Section heading for the pricing preview',
  },
  SUBTITLE: {
    id: 'homepage.pricing_preview.subtitle',
    text: 'Start free. Scale when you\'re ready. No surprises.',
    description: 'Subtitle for the pricing preview',
  },
  FREE_PRICE: { id: 'homepage.pricing_preview.free_price', text: '$0', description: 'Free plan price' },
  FREE_WORDS: { id: 'homepage.pricing_preview.free_words', text: '5,000 words', description: 'Free plan word limit' },
  STARTER_PRICE: { id: 'homepage.pricing_preview.starter_price', text: '$9', description: 'Starter plan price' },
  STARTER_WORDS: { id: 'homepage.pricing_preview.starter_words', text: '50,000 words/yr', description: 'Starter plan word limit' },
  GROWTH_PRICE: { id: 'homepage.pricing_preview.growth_price', text: '$29', description: 'Growth plan price' },
  GROWTH_WORDS: { id: 'homepage.pricing_preview.growth_words', text: '250,000 words/yr', description: 'Growth plan word limit' },
  SCALE_PRICE: { id: 'homepage.pricing_preview.scale_price', text: '$79', description: 'Scale plan price' },
  SCALE_WORDS: { id: 'homepage.pricing_preview.scale_words', text: '1M words/yr', description: 'Scale plan word limit' },
  /*
   * The homepage said only "/mo". Every paid plan is billed as a single annual
   * charge — PlanConfig.annualPrice() is monthlyPrice x 12 and there is one Stripe
   * price per plan — so a visitor who decided on $9 met $108 at checkout. New id,
   * because the old text is not a translation of this one.
   */
  PER_MONTH: {
    id: 'homepage.pricing_preview.per_month_v2',
    text: '/mo, billed annually',
    description: 'Suffix after a plan price, e.g. "$9/mo, billed annually". States that the monthly figure is charged as one yearly payment. Matches the wording already used on the pricing page.',
  },
  FOREVER: { id: 'homepage.pricing_preview.forever', text: 'forever', description: 'Forever suffix for free plan' },
  FEATURE_LOCALES: { id: 'homepage.pricing_preview.feature_locales', text: '56 locales', description: 'Feature bullet' },
  FEATURE_CLI: { id: 'homepage.pricing_preview.feature_cli', text: 'CLI + API + MCP', description: 'Feature bullet' },
  FEATURE_DASHBOARD: { id: 'homepage.pricing_preview.feature_dashboard', text: 'Web dashboard', description: 'Feature bullet' },
  FEATURE_VARIABLES: { id: 'homepage.pricing_preview.feature_variables', text: 'Variable-safe', description: 'Feature bullet' },
  BTN_VIEW_PLANS: { id: 'homepage.pricing_preview.btn_view_plans', text: 'View Full Pricing', description: 'CTA button' },
  NO_CC: { id: 'homepage.pricing_preview.no_cc', text: 'No credit card required · Cancel anytime', description: 'Reassurance text' },
});
